import {
  BookOpen,
  CalendarRange,
  ChartColumn,
  CircleQuestionMark,
  ClipboardList,
  FileText,
  FileType,
  FlaskConical,
  Gavel,
  Lightbulb,
  NotebookPen,
  Presentation,
  SearchCheck,
  Users,
  type LucideIcon,
} from "lucide-react";
import { NOTE_KIND } from "@brainlog/shared";

export const KIND_ICON: Record<string, LucideIcon> = {
  note: FileText,
  research_question: CircleQuestionMark,
  hypothesis: Lightbulb,
  study_plan: ClipboardList,
  study_execution: FlaskConical,
  result: ChartColumn,
  meeting: Users,
  decision: Gavel,
  research_log: NotebookPen,
  reading_note: BookOpen,
  search_log: SearchCheck,
  manuscript_section: FileType,
  progress_note: CalendarRange,
  slides: Presentation,
};

export function kindLabel(kind: string) {
  return (NOTE_KIND.labels as Record<string, string>)[kind] ?? kind;
}

export function KindIcon({ kind, className }: { kind: string; className?: string }) {
  const Icon = KIND_ICON[kind] ?? FileText;
  return <Icon className={className ?? "size-4 shrink-0 text-muted-foreground"} aria-hidden />;
}
